<template>
  <div>
    <div class="detail-info">
      <span class="info-title">类型：</span>
      <four-level :is-smart="true" :only-look="true" :level="form.illness_level"/>
    </div>
    <div class="detail-info">
      <div class="info-title description">详细描述：</div>
      <span class="info-item">{{ form.details }}</span>
    </div>
  </div>

</template>

<script>
import FourLevel from "@components/common/FourLevel";
import { mapState } from "vuex";

export default {
  name: "SituationLook",
  components: { FourLevel },
  data() {
    return {
      form: {
        illness_level: "",
        details: ""
      }
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
  },
  watch: {
    patient: {
      handler(val) {
        const { nobody_medicalstatus } = val;
        if (nobody_medicalstatus.length) {
          const { type, content } = nobody_medicalstatus[0];
          this.form = {
            illness_level: type, details: content,
          };
        }
      },
      immediate: true
    }
  },

};
</script>

<style scoped lang="scss">
.detail-info {
  > div {
    display: inline-block;
  }
}
</style>
